// extracted by mini-css-extract-plugin
export default {"container":"ManageContentTable_container__YjmQ4","create":"ManageContentTable_create__B-75U","icon":"ManageContentTable_icon__ZgiF-"};